// generated by genversion
const version = '6.0.23';

export { version };
//# sourceMappingURL=version.mjs.map
